
export const BASE_URL = process.env.GATSBY_BASE_URL;
//export const BASE_URL = "https://api.m3e-gmbh.com";
//export const BASE_URL = "https://m3e-agency.com";
//export const BASE_URL = "http://127.0.0.1:8000";
